import React from "react";
import { providerNames } from "./provider-model-catalog.mjs";

// Both constructor inspectors receive sorted, deduplicated choices.
export function ModelChoiceOptions({ choices }) {
  const groups = new Map();
  for (const choice of choices) {
    if (!groups.has(choice.provider)) groups.set(choice.provider, []);
    groups.get(choice.provider).push(choice);
  }
  return [...groups].map(([provider, models]) => {
    const options = models.map(choice => <option key={choice.choiceRef} value={choice.choiceRef}>{choice.label}</option>);
    return provider ? <optgroup key={provider} label={providerNames[provider] || provider}>{options}</optgroup> : options;
  });
}
